<template>
    <div>
        <modal :show.sync="showModal" size="lg">
            <h6 slot="header" class="modal-title">Listado de Siniestros: </h6>
            <div class="container">
                <div class="row">
                    <div class="table-responsive">
                        <base-table class="table  mt-5"
                                    :data="listado">
                            <template slot="columns">
                                <th class="text-center px-0 bg-transparent" scope="col">
                                    <span class="font-weight-700">ID</span>
                                </th>
                                <th class="text-center bg-transparent" scope="col">Estado</th>
                                <th class="text-center bg-transparent" scope="col">Tipo Siniestro</th>
                                <th class="text-center bg-transparent" scope="col">Fecha Siniestro</th>
                                <th class="text-center bg-transparent" scope="col">Formulario</th>
                                <th class="text-center bg-transparent" scope="col">Finiquito</th>
                                <th class="text-center bg-transparent" scope="col">Acciones</th>
                                <th class="text-center bg-transparent" scope="col">Comentario</th>
                                <th class="text-center bg-transparent" scope="col">Eliminar</th>
                            </template>
                            
                            <template slot-scope="{row}">
                                <td class="text-center px-0">{{row.id}} </td>
                                <!--<td class="text-center" v-html="row.tipo_campo"></td>-->
                                <td class="text-center">{{ row.estado }}</td>
                                <td class="text-center">{{ row.tipo_siniestro }}</td>
                                <td class="text-center">{{ row.fecha_siniestro }}</td>
                                <td class="text-center"><base-button icon @click="verFormulario(row.id)" v-if="true" type="primary" size="sm" ><i class="fa fa-file"></i> Ver formulario</base-button></td>
                                <td class="text-center">
                                    <div  class="list-group list-group-flush w-100 align-items-stretch">
                                        <base-button
                                            style="margin-right: 0rem;"
                                            
                                            class="edit"
                                            type="default"
                                            size="sm"
                                            icon
                                            @click="verFiniquito(row.id)"
                                        >
                                            <i class="text-white fa fa-file"></i> Ver Finiquito
                                        </base-button>
                                        &nbsp;
                                        <base-button
                                            
                                            class="edit"
                                            type="warning"
                                            size="sm"
                                            icon
                                            :disabled="row.estado != 'DECLARADO'"
                                            @click="modalFirma(row.id)"
                                        >
                                            <i class="text-white ni ni-ruler-pencil"></i> Firmar Finiquito
                                        </base-button>
                                    </div>
                                </td>
                                <td class="d-flex">
                                    <el-tooltip content="Liquidar" placement="top">
                                        <base-button :disabled="row.estado != 'DECLARADO'" @click="siniestrar(row.id, 'liquidar')" type="slack" class="btn-icon-only rounded-circle">
                                            <span class="btn-inner--icon"><i class="ni ni-check-bold"></i></span>
                                        </base-button>
                                    </el-tooltip>
                                    <el-tooltip content="Anular" placement="top">
                                        <base-button :disabled="row.estado != 'DECLARADO'" @click="siniestrar(row.id, 'anular')" type="google-plus" class="btn-icon-only rounded-circle">
                                            <span class="btn-inner--icon"><i class="fas fa-ban"></i></span>
                                        </base-button>
                                    </el-tooltip>
                                    <el-tooltip content="Rechazar" placement="top">
                                        <base-button :disabled="row.estado != 'DECLARADO'" @click="siniestrar(row.id, 'rechazar')" type="youtube" class="btn-icon-only rounded-circle">
                                            <span class="btn-inner--icon"><i class="fas fa-times"></i></span>
                                        </base-button>
                                    </el-tooltip>
                                </td>
                                <td class="text-center">{{ row.comentario }}</td>
                                <td class="text-center"><base-button size="sm" nativeType="button" type="danger" @click="eliminarSiniestro(row.id)"><i class="fa fa-trash"></i></base-button></td>
                            </template>
                            
                        </base-table>
                    </div>
                </div>

            </div>
            <template slot="footer">
                <base-button  type="primary" @click="showModal = false" >Aceptar</base-button>
            </template>
        </modal>
        <siniestro-pdf></siniestro-pdf>
        <finiquito-pdf></finiquito-pdf>
        <firmar-finiquito></firmar-finiquito>
    </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import swal from 'sweetalert2';
import SiniestroPdf from '@/views/Siniestros/SiniestroPdf.vue';
import FiniquitoPdf from '@/views/Siniestros/FiniquitoPdf.vue';
import FirmarFiniquito from '@/views/Siniestros/FirmarFiniquito.vue';
export default {
    components: {
        BaseTable,
        SiniestroPdf,
        FiniquitoPdf,
        FirmarFiniquito
    },
    data(){
        return {
            showModal: false,
            venta_id: undefined,
            listado: []
        }
    },
    methods: {
        eliminarSiniestro(siniestro_id)
        {
            var vm = this;
            swal({
                title: 'Estás segur@?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Si, Eliminar siniestro',
                buttonsStyling: false
            }).then( result => {
                if (result.value) {
                    vm.axios({
                        url: 'api/siniestros/eliminar',
                        method: 'POST',
                        data: {
                            siniestro_id
                        }
                    }).then( response => {
                        vm.fetchData(vm.venta_id);
                        vm.$notify({ type: 'success', message: 'Siniestro eliminado'});
                    }).catch( error => {
                        vm.$notify({ type: 'danger', message: 'No se pudo eliminar el siniestro'});
                        if( error.response.data ){
                            vm.$notify({ type: 'danger', message: error.response.data});
                        }
                    });
                }
            });
                    
        },
        siniestrar(siniestro_id, accion)
        {
            var vm = this;
            if(true || accion == 'rechazar'){
                const { value: text } =  swal({
                    input: 'textarea',
                    title: 'Ingrese el motivo de '+accion,
                    inputPlaceholder: 'Ingrese el motivo aqui...',
                    inputAttributes: {
                        'aria-label': 'Ingrese el motivo aqui...'
                    },
                    showCancelButton: true
                }).then( result  => {
                    if( result.hasOwnProperty('value') ){
                        if( result.value ){
                            console.log('se tendria que enviar ');
                            vm.axios({
                                method: 'POST',
                                url: 'api/siniestros/siniestrar',
                                data: {
                                siniestro_id,
                                accion,
                                motivo: result.value,
                                }
                            }).then( response =>{
                                vm.$notify({
                                    message: 'Accion concretada',
                                    type: 'success'
                                });
                                vm.fetchData(vm.venta_id);

                            }).catch( error => {
                                vm.$notify({
                                    message: 'Hubo un error, no se pudo realizar la accion '+accion,
                                    type: 'danger'
                                });
                                console.log(error);
                            });
                        }else{
                            vm.$notify({
                                message: 'El campo motivo no puede ir vacío',
                                type: 'warning'
                            });
                        }
                    }
                });
                
            }else{
                swal({
                    title: 'Estás segur@?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: 'Si, vamos!',
                    buttonsStyling: false
                }).then( result => {
                    if (result.value) {
                        vm.axios({
                            method: 'POST',
                            url: 'api/siniestros/siniestrar',
                            data: {
                            siniestro_id,
                            accion
                            }
                        }).then( response =>{
                            vm.$notify({
                                message: 'Accion concretada',
                                type: 'success'
                            });
                            vm.fetchData(vm.venta_id);

                        }).catch( error => {
                            vm.$notify({
                                message: 'Hubo un error, no se pudo realizar la accion',
                                type: 'danger'
                            });
                            console.log(error);
                        });
                    }
                });
            }
                
        },
        verFormulario(siniestro_id)
        {
            this.$emit('loadSiniestroPdf', {entity: 'siniestro', id: siniestro_id});
        },
        verFiniquito(siniestro_id)
        {
            this.$emit('loadFiniquitoPdf', {entity: 'finiquito', id: siniestro_id});
        },
        modalFirma(id)
        {
            this.$emit('loadFirmarFiniquito', id );
        },
        fetchData(venta_id){
            var vm = this;
            this.axios({
                url: 'api/siniestros/list_by_venta',
                method: 'POST',
                data: {
                    venta_id
                }
            }).then( response => {
                console.log('la data', response.data);
                vm.listado = response.data;
            }).catch( error => {
                vm.showModal = false;
                vm.$notify({
                    message: 'Ocurrio un error al consultar siniestros',
                    type: 'danger'
                })
                console.log(error);
            });
        }
    },
    created(){
        var vm = this;
        this.$parent.$on('loadListaSiniestros', (venta_id) => {
            vm.venta_id = venta_id;
            vm.fetchData(venta_id);
            vm.showModal= true;
        });
    }
}
</script>